import styled from 'styled-components';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';

export default function InecoRiskManagerRiskGoalCard({
  goal,
  onShowGoalModal,
  onShowKpiModal,
}) {
  return (
    <>
      <AppCard
        header={
          <>
            <span>Meta</span>
            <span
              className="pointer float-right"
              title="Editar"
              onClick={onShowGoalModal}
            >
              <AppRemixIcon icon="edit-box" />
            </span>
          </>
        }
        headerClassName="text-white bg-primary"
      >
        <div className="d-flex flex justify-content-between">
          <div className="mb-2">
            <span className="font-weight-bold mr-2">Descripción:</span>
            <span>{goal?.description}</span>
          </div>
        </div>
      </AppCard>
      <button
        type="button"
        className="btn btn-xs btn-success float-right mt-3"
        onClick={onShowKpiModal}
      >
        Nuevo KPI
      </button>
    </>
  );
}

const CardBlock = styled.div`
  min-height: 60px;
`;
